import { BaseControl } from "./BaseControl";
import { Controller } from "./Controller";

export class TextControl extends BaseControl {

    constructor(protected input: HTMLInputElement, controller: Controller, field: string) {
        super(controller, field);

        if (controller.automaticUpdateModel) {
            // save new value on lost focus
            input.addEventListener("blur", this.onBlur);

            // save new value on return
            input.addEventListener("keydown", this.onKeyDown);
        }
    }

    onBlur = (ev: Event) => {
        this.saveValue(this.input.value);
    }

    onKeyDown = (ev: KeyboardEvent) => {
        if (ev.keyCode == 13) {
            this.saveValue(this.input.value);
        }
    }

    dispose() {
        this.input.removeEventListener("blur", this.onBlur);
        this.input.removeEventListener("keydown", this.onKeyDown);
    }

    updateControlFromModel() {
        let value = this.getModelValue();
        this.input.value = value ? value : "";
    }

    updateModelFromControl() {
        this.setModelValue(this.input.value);
    }

    validate() {
    }

    focus() {
        this.input.focus();
    }
}
